import { general_states, warehouselocationtype_type, counting_strategy_type, customer_type } from "./staticEnums";

const orderRelationStateMap = (theme) => ({
    [general_states.OPEN]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "processing",
        state: general_states.OPEN, 
    },
    [general_states.SHIPPED]: {
        labelcolor: "green",
        labeltext: "shipped",
        state: general_states.SHIPPED, 
    },
    [general_states.ACTION_REQUIRED_CUSTOMER]: {
        labelcolor: "red",
        labeltext: "action_required",
        state: general_states.ACTION_REQUIRED_CUSTOMER, 
    },
    [general_states.CANCELLED]: {
        labelcolor: theme.palette.mode === "dark" ? "white" : "grey",
        labeltext: "cancelled",
        state: general_states.CANCELLED, 
    },
    [general_states.BACKORDERED]: {
        labelcolor: "pink",
        labeltext: "backordered",
        state: general_states.BACKORDERED, 
    },
    [general_states.SNOOZE]: {
        labelcolor: "pink",
        labeltext: "snooze",
        state: general_states.SNOOZE, 
    },
    [general_states.UNKNOWN]: {
        labelcolor: "orange",
        labeltext: "unknown",
        state: general_states.UNKNOWN, 
    },
});

const orderStateMap = (theme) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE, 
    },
    [general_states.OPEN]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "order_can_be_picked",
        state: general_states.OPEN, 
    },
    [general_states.ECHECK]: {
        labelcolor: "orange",
        labeltext: "process_shipment",
        state: general_states.ECHECK, 
    },
    [general_states.ECHECKPAUSED]: {
        labelcolor: "orange",
        labeltext: "process_shipment_paused",
        state: general_states.ECHECKPAUSED, 
    },
    [general_states.TO_PROCESS]: {
        labelcolor: "orange",
        labeltext: "to_process",
        state: general_states.TO_PROCESS, 
    },
    [general_states.SHIPPED]: {
        labelcolor: "green",
        labeltext: "shipped",
        state: general_states.SHIPPED, 
    },
    [general_states.FULLYPICKED]: {
        labelcolor: "green",
        labeltext: "fullypicked",
        state: general_states.FULLYPICKED, 
    },
    [general_states.PICKED]: {
        labelcolor: "green",
        labeltext: "picked",
        state: general_states.PICKED, 
    },
    [general_states.BLOCKED]: {
        labelcolor: "red",
        labeltext: "blocked",
        state: general_states.BLOCKED, 
    },
    [general_states.MAINTENANCE]: {
        labelcolor: "red",
        labeltext: "action_required",
        state: general_states.MAINTENANCE, 
    },
    [general_states.ACTION_REQUIRED_CUSTOMER]: {
        labelcolor: "red",
        labeltext: "action_required",
        state: general_states.ACTION_REQUIRED_CUSTOMER, 
    },
    [general_states.ACTION_REQUIRED_WAREHOUSE]: {
        labelcolor: "red",
        labeltext: "action_required",
        state: general_states.ACTION_REQUIRED_WAREHOUSE, 
    },
    [general_states.CANCELLED]: {
        labelcolor: theme.palette.mode === "dark" ? "white" : "grey",
        labeltext: "cancelled",
        state: general_states.CANCELLED, 
    },
    [general_states.REPLENISH]: {
        labelcolor: "purple",
        labeltext: "replenish",
        state: general_states.REPLENISH, 
    },
    [general_states.BACKORDERED]: {
        labelcolor: "pink",
        labeltext: "backordered",
        state: general_states.BACKORDERED, 
    },
    [general_states.SNOOZE]: {
        labelcolor: "pink",
        labeltext: "snooze",
        state: general_states.SNOOZE, 
    },
    [general_states.PICKING_IN_PROGRESS]: {
        labelcolor: "purple",
        labeltext: "picking_in_progress",
        state: general_states.PICKING_IN_PROGRESS, 
    },
    [general_states.UNKNOWN]: {
        labelcolor: "orange",
        labeltext: "unknown",
        state: general_states.UNKNOWN, 
    },
});

const getOrderStateData = (state, theme, isRelation = false, snoozeWhenAvailable = false) => {
    // A backordered order flagged with snoozeWhenAvailable stays backordered but will land in
    // snooze once its backorder resolves, so it reads as both
    if (snoozeWhenAvailable && state === general_states.BACKORDERED) {
        return {
            labelcolor: "pink",
            labeltext: "backordered_snooze",
            state: general_states.BACKORDERED
        }
    }

    if(isRelation && [general_states.OPEN,
        general_states.ACTIVE, 
        general_states.PICKING_IN_PROGRESS, 
        general_states.FULLYPICKED, 
        general_states.REPLENISH, 
        general_states.ECHECKPAUSED, 
        general_states.TO_PROCESS,
        general_states.PICKED,
        general_states.ACTION_REQUIRED_WAREHOUSE].includes(state)) {
        return {
            labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
            labeltext: "processing",
            state: state
        }
    }
    
    // Retrieve the stateMapping with the current theme
    const states = orderStateMap(theme);

    // Return the value corresponding to the state, or a default
    return states[state] || states[general_states.UNKNOWN];
};

const importOrderStateMap = (theme) => ({
    [general_states.IGNORED]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "ignored",
        state: general_states.IGNORED,
    },
    [general_states.FAILED]: {
        labelcolor: "red",
        labeltext: "failed",
        state: general_states.FAILED,
    },
    [general_states.IMPORTED]: {
        labelcolor: "green",
        labeltext: "imported",
        state: general_states.IMPORTED,
    },
});

const getImportOrderStateData = (state, theme) => {
    const states = importOrderStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

const supportTicketStateMap = (theme) => ({
    [general_states.OPEN]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "open",
        state: general_states.OPEN,
    },
    [general_states.IN_PROGRESS]: {
        labelcolor: "orange",
        labeltext: "in_progress",
        state: general_states.IN_PROGRESS,
    },
    [general_states.RESOLVED]: {
        labelcolor: "green",
        labeltext: "resolved",
        state: general_states.RESOLVED,
    },
    [general_states.CLOSED]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "closed",
        state: general_states.CLOSED,
    },
});

const getSupportTicketStateData = (state, theme) => {
    const states = supportTicketStateMap(theme);
    return states[state] || states[general_states.OPEN];
};

// Priority colour-and-label map. Mirrors the support_ticket_priority enum.
// LOW/MEDIUM stay neutral; HIGH warns; URGENT is the only red — keep it scarce
// so the chip actually reads as urgent when it shows up.
const supportTicketPriorityMap = (theme) => ({
    low: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "low",
        state: "low",
    },
    medium: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "medium",
        state: "medium",
    },
    high: {
        labelcolor: "orange",
        labeltext: "high",
        state: "high",
    },
    urgent: {
        labelcolor: "red",
        labeltext: "urgent",
        state: "urgent",
    },
});

const getSupportTicketPriorityData = (priority, theme) => {
    const map = supportTicketPriorityMap(theme);
    return map[priority] || map.medium;
};

const returnStateMap = (theme, ignoreLineStates = false) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "is_expected",
        state: general_states.ACTIVE,
    },
    [general_states.PROCESSED]: {
        labelcolor: "green",
        labeltext: "processed",
        state: general_states.PROCESSED,
    },
    [general_states.FAILED]: {
        labelcolor: "red",
        labeltext: "failed",
        state: general_states.FAILED,
    },
    ...(!ignoreLineStates ? {
        [general_states.ACCEPTED]: {
            labelcolor: "green",
            labeltext: "accepted",
            state: general_states.ACCEPTED,
        }
    } : {}),
    ...(!ignoreLineStates ? {
        [general_states.DECLINED]: {
            labelcolor: "red",
            labeltext: "declined",
            state: general_states.DECLINED,
        }
    } : {}),
    [general_states.COMPLETED]: {
        labelcolor: "green",
        labeltext: "completed",
        state: general_states.COMPLETED,
    },

    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getReturnStateData = (state, theme) => {
    const states = returnStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

const replenishStateMap = (theme) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE,
    },
    [general_states.PICKING_IN_PROGRESS]: {
        labelcolor: "purple",
        labeltext: "in_progress",
        state: general_states.PICKING_IN_PROGRESS,
    },
    [general_states.COMPLETED]: {
        labelcolor: "green",
        labeltext: "completed",
        state: general_states.COMPLETED,
    },
    [general_states.CANCELLED]: {
        labelcolor: "grey",
        labeltext: "cancelled",
        state: general_states.CANCELLED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getReplenishStateData = (state, theme) => {
    const states = replenishStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

const inboundStateMap = (theme) => ({
    [general_states.CONCEPT]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "concept",
        state: general_states.CONCEPT,
    },
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "expected",
        state: general_states.ACTIVE,
    },
    [general_states.CANCELLED]: {
        labelcolor: "red",
        labeltext: "cancelled",
        state: general_states.CANCELLED,
    },
    [general_states.PARTLYRECEIVED]: {
        labelcolor: "orange",
        labeltext: "partly_received",
        state: general_states.PARTLYRECEIVED,
    },
    [general_states.FULLYRECEIVED]: {
        labelcolor: "pink",
        labeltext: "fully_received",
        state: general_states.FULLYRECEIVED,
    },
    [general_states.COMPLETED]: {
        labelcolor: "green",
        labeltext: "completed",
        state: general_states.COMPLETED,
    },
    [general_states.AWAITING_APPROVAL]: {
        labelcolor: "orange",
        labeltext: "awaiting_approval",
        state: general_states.AWAITING_APPROVAL,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

// A closed inbound or line that received less than was forecasted keeps its state, but is
// labelled as a shortage so the difference stays visible instead of reading as fully received.
const getInboundStateData = (state, theme, incompleteReceived = false) => {
    const states = inboundStateMap(theme);

    if (incompleteReceived) {
        const shortage = {
            labelcolor: "red",
            labeltext: "incomplete_received",
            state,
        };

        // Being completed says something the shortage does not, so a completed line keeps its own
        // label and carries the shortage alongside it in extraLabel.
        if (state === general_states.COMPLETED) {
            return { ...states[general_states.COMPLETED], extraLabel: shortage };
        }

        return shortage;
    }

    return states[state] || states[general_states.UNKNOWN];
};


const bolReplenishmentStateMap = (theme) => ({
    "open": {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "open",
        state: "open",
    },
    "bol_announced": {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "bol_announced",
        state: "bol_announced",
    },
    "bol_in_transit": {
        labelcolor: "purple",
        labeltext: "bol_in_transit",
        state: "bol_in_transit",
    },
    "bol_arrived_at_wh": {
        labelcolor: "orange",
        labeltext: "bol_arrived_at_wh",
        state: "bol_arrived_at_wh",
    },
    "bol_in_progress_at_wh": {
        labelcolor: "pink",
        labeltext: "bol_in_progress_at_wh",
        state: "bol_in_progress_at_wh",
    },
    "bol_done": {
        labelcolor: "green",
        labeltext: "bol_done",
        state: "bol_done",
    },
    "bol_cancelled": {
        labelcolor: "red",
        labeltext: "bol_cancelled",
        state: "bol_cancelled",
    },
    "cancelled": {
        labelcolor: "red",
        labeltext: "cancelled",
        state: "cancelled",
    },
    "approved": {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "approved",
        state: "approved",
    },
    "completed": {
        labelcolor: "green",
        labeltext: "completed",
        state: "completed",
    },
    "rejected": {
        labelcolor: "red",
        labeltext: "rejected",
        state: "rejected",
    },
    [general_states.UNKNOWN]: {
        labelcolor:theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getBolReplenishmentStateData = (state, theme) => {
    const states = bolReplenishmentStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

const amazonReplenishmentStateMap = (theme) => ({
    "open": {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "open",
        state: "open",
    },
    "approved": {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "approved",
        state: "approved",
    },
    "amazon_shipped": {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "amazon_shipped",
        state: "amazon_shipped",
    },
    "amazon_in_transit": {
        labelcolor: "purple",
        labeltext: "amazon_in_transit",
        state: "amazon_in_transit",
    },
    "amazon_delivered": {
        labelcolor: "orange",
        labeltext: "amazon_delivered",
        state: "amazon_delivered",
    },
    "amazon_checked_in": {
        labelcolor: "orange",
        labeltext: "amazon_checked_in",
        state: "amazon_checked_in",
    },
    "amazon_receiving": {
        labelcolor: "pink",
        labeltext: "amazon_receiving",
        state: "amazon_receiving",
    },
    "amazon_closed": {
        labelcolor: "green",
        labeltext: "amazon_closed",
        state: "amazon_closed",
    },
    "amazon_cancelled": {
        labelcolor: "red",
        labeltext: "amazon_cancelled",
        state: "amazon_cancelled",
    },
    "rejected": {
        labelcolor: "red",
        labeltext: "rejected",
        state: "rejected",
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getAmazonReplenishmentStateData = (state, theme) => {
    const states = amazonReplenishmentStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

// const getInboundStateData = (state, theme) => {
//     let labelcolor = "";
//     let labeltext = "";

//     switch(state){
//         case general_states.ACTIVE:
//             labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
//             labeltext = "active";
//             break;
//         case general_states.CANCELLED:
//             labelcolor = "red"
//             labeltext = "cancelled";
//             break;
//         case general_states.PARTLYRECEIVED:
//             labelcolor = "orange"
//             labeltext = "partly_received";
//             break;
//         case general_states.FULLYRECEIVED:
//             labelcolor = "pink"
//             labeltext = "fully_received";
//             break;
//         case general_states.COMPLETED:
//             labelcolor = "green"
//             labeltext = "completed";
//             break;
//         default:
//             labelcolor = "grey"
//             labeltext = "unknown";
//             break;
//     }

//     return {
//         labelcolor,
//         labeltext
//     }
// }


const invoiceStateMap = (theme) => ({
    [general_states.CONCEPT]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "concept",
        state: general_states.CONCEPT,
    },
    [general_states.FINALIZED]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "final",
        state: general_states.FINALIZED,
    },
    [general_states.EXPORTED]: {
        labelcolor: "orange",
        labeltext: "exported",
        state: general_states.EXPORTED,
    },
    [general_states.SENT]: {
        labelcolor: "pink",
        labeltext: "sent",
        state: general_states.SENT,
    },
    [general_states.PAID]: {
        labelcolor: "green",
        labeltext: "paid",
        state: general_states.PAID,
    },
    [general_states.REMINDED]: {
        labelcolor: "red",
        labeltext: "reminded",
        state: general_states.REMINDED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getInvoiceMutationStateData = (state, theme) => {
    const states = invoiceMutationStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

const invoiceMutationStateMap = (theme) => ({
    [general_states.CONCEPT]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "concept",
        state: general_states.CONCEPT,
    },
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE,
    },
    [general_states.DELETED]: {
        labelcolor: "red",
        labeltext: "deleted",
        state: general_states.DELETED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getInvoiceStateData = (state, theme) => {
    const states = invoiceStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

// const getInvoiceStateData = (state, theme) => {
//     let labelcolor = "";
//     let labeltext = "";

//     switch(state){
//         case general_states.CONCEPT:
//             labelcolor = "grey"
//             labeltext = "concept";
//             break;
//         case general_states.FINALIZED:
//             labelcolor = "green";
//             labeltext = "final";
//             break;
//         case general_states.EXPORTED:
//             labelcolor = "orange"
//             labeltext = "exported";
//             break;
//         case general_states.SENT:
//             labelcolor = "pink"
//             labeltext = "sent";
//             break;
//         case general_states.PAID:
//             labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
//             labeltext = "paid";
//             break;
//         default:
//             labelcolor = "grey"
//             labeltext = "unknown";
//             break;
//     }

//     return {
//         labelcolor,
//         labeltext
//     }
// }


const productsStateMap = (theme) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getProductsStateData = (state, theme) => {
    const states = productsStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};

// const getProductsStateData = (state, theme) => {
//     let labelcolor = "";
//     let labeltext = "";

//     switch(state){
//         case general_states.ACTIVE:
//             labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
//             labeltext = "active";
//             break;
//         default:
//             labelcolor = "grey"
//             labeltext = "unknown";
//             break;
//     }

//     return {
//         labelcolor,
//         labeltext
//     }
// }


const locationsStateMap = (theme) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getLocationsStateData = (state, theme) => {
    const states = locationsStateMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};



const pickingJobStateData = (theme) => ({
    [general_states.FULLYPICKED]: {
        labelcolor: "purple",
        labeltext: "picked",
        state: general_states.FULLYPICKED,
    },
    [general_states.PICKING_IN_PROGRESS]: {
        labelcolor: "urbangreen",
        labeltext: "in_progress",
        state: general_states.PICKING_IN_PROGRESS,
    },
    [general_states.IN_PROGRESS]: {
        labelcolor: "urbangreen",
        labeltext: "in_progress",
        state: general_states.IN_PROGRESS,
    },
    [general_states.ECHECK]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "echeck",
        state: general_states.ECHECK,
    },
    [general_states.COMPLETED]: {
        labelcolor: "cyan",
        labeltext: "picked",
        state: general_states.COMPLETED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getPickingJobStateData = (state, theme) => {
    const states = pickingJobStateData(theme);
    return states[state] || states[general_states.UNKNOWN];
};


const pickingJobStepData = (theme) => ({
    [general_states.BLOCKED]: {
        labelcolor: "red",
        labeltext: "blocked",
        state: general_states.BLOCKED,
    },
    [general_states.CANCELLED]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "cancelled",
        state: general_states.CANCELLED,
    },
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        state: general_states.ACTIVE,
    },
    [general_states.COMPLETED]: {
        labelcolor: "green",
        labeltext: "fullypicked",
        state: general_states.COMPLETED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getPickingJobStepData = (state, theme) => {
    const states = pickingJobStepData(theme);
    return states[state] || states[general_states.UNKNOWN];
};


// const getLocationsStateData = (state, theme) => {
//     let labelcolor = "";
//     let labeltext = "";

//     switch(state){
//         case general_states.ACTIVE:
//             labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
//             labeltext = "active";
//             break;
//         default:
//             labelcolor = "grey"
//             labeltext = "unknown";
//             break;
//     }

//     return {
//         labelcolor,
//         labeltext
//     }
// }


const wareHouseLocationTypeMap = (theme) => ({
    [warehouselocationtype_type.GENERAL]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "pick",
        type: warehouselocationtype_type.GENERAL,
    },
    [warehouselocationtype_type.BULK]: {
        labelcolor: "orange",
        labeltext: "bulk",
        type: warehouselocationtype_type.BULK,
    },
    [warehouselocationtype_type.ECHECK]: {
        labelcolor: "green",
        labeltext: "echeck",
        type: warehouselocationtype_type.ECHECK,
    },
    [warehouselocationtype_type.LINK]: {
        labelcolor: "red",
        labeltext: "link",
        type: warehouselocationtype_type.LINK,
    },
    [warehouselocationtype_type.TEMP]: {
        labelcolor: "yellow",
        labeltext: "temp",
        type: warehouselocationtype_type.TEMP,
    },
    [warehouselocationtype_type.TRANSITION]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "transition",
        type: warehouselocationtype_type.TRANSITION,
    },
    [warehouselocationtype_type.RETURNS]: {
        labelcolor: "pink",
        labeltext: "returns",
        type: warehouselocationtype_type.RETURNS,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getWarehouseLocationLabelData = (state, theme) => {
    const states = wareHouseLocationTypeMap(theme);
    return states[state] || states[general_states.UNKNOWN];
};


const countingStategyTypeMap = (theme) => ({
    [counting_strategy_type.PICKING_LOCATIONS]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "picking_locations",
        type: counting_strategy_type.PICKING_LOCATIONS,
    },
    [counting_strategy_type.BULK_LOCATIONS]: {
        labelcolor: "orange",
        labeltext: "bulk_locations",
        type: counting_strategy_type.BULK_LOCATIONS,
    },
    [counting_strategy_type.ALL_LOCATIONS]: {
        labelcolor: "green",
        labeltext: "all_locations",
        type: counting_strategy_type.ALL_LOCATIONS,
    },
    [counting_strategy_type.INVENTORY_TURNOVER_RATION]: {
        labelcolor: "pink",
        labeltext: "inventory_turnover_ratio",
        type: counting_strategy_type.INVENTORY_TURNOVER_RATION,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getCountingStategyLabelData = (type, theme) => {
    const states = countingStategyTypeMap(theme);
    return states[type] || states[general_states.UNKNOWN];
};

const serialNumberStateLabeldata = (theme) => ({
    [general_states.CONCEPT]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "concept",
        type: general_states.CONCEPT,
    },
    [general_states.RECEIVED]: {
        labelcolor: "pink",
        labeltext: "received",
        type: general_states.RECEIVED,
    },
    [general_states.ACTIVE]: {
        labelcolor: "green",
        labeltext: "active",
        type: general_states.ACTIVE,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getSerialNumberStateLabeldata = (type, theme) => {
    const states = serialNumberStateLabeldata(theme);
    return states[type] || states[general_states.UNKNOWN];
};


const relationStateLabelData = (theme) => ({
    [general_states.ACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "active",
        type: general_states.ACTIVE,
    },
    [general_states.DELETED]: {
        labelcolor: "red",
        labeltext: "deleted",
        type: general_states.DELETED,
    },
    [general_states.INACTIVE]: {
        labelcolor: "orange",
        labeltext: "inactive",
        type: general_states.INACTIVE,
    },
    [general_states.BLOCKED]: {
        labelcolor: "purple",
        labeltext: "blocked",
        type: general_states.BLOCKED,
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getRelationStateLabelData = (type, theme) => {
    const states = relationStateLabelData(theme);
    return states[type] || states[general_states.UNKNOWN];
};

const shipmentStatusMap = (theme) => ({
    "underway": {
        labelcolor: "primary",
        labeltext: "underway",
        type: "underway",
    },
    "delivered": {
        labelcolor: "green",
        labeltext: "delivered",
        type: "delivered",
    },
    "not_delivered": {
        labelcolor: "red",
        labeltext: "not_delivered",
        type: "not_delivered",
    },
    "not_fetched": {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "not_fetched",
        state: "not_fetched",
    },
    [general_states.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        state: general_states.UNKNOWN,
    },
});

const getShipmentStatusLabeldata = (type, theme) => {
    const states = shipmentStatusMap(theme);
    return states[type] || states[general_states.UNKNOWN];
};


// Claim statuses. One definition feeds the labels on the claim grids, the claim sidepanel and
// the status filter, so a colour is only ever chosen here. The colour names are the filter's
// theme-independent vocabulary; claimStatusMap resolves the two that differ per theme.
const claimStatuses = [
    { value: "open", color: "orange" },
    { value: "sent", color: "blue" },
    { value: "replied", color: "purple" },
    { value: "answered", color: "green" },
    { value: "closed", color: "grey" },
    { value: "failed", color: "red" },
];

const claimStatusMap = (theme) => Object.fromEntries(
    claimStatuses.map(({ value, color }) => [value, {
        labelcolor: color === "blue"
            ? (theme.palette.mode === "dark" ? "blue" : "primary")
            : color === "grey"
                ? (theme.palette.mode === "dark" ? "greyLight" : "grey")
                : color,
        labeltext: `claim_status_${value}`,
        type: value,
    }])
);

const getClaimStatusLabeldata = (type, theme) => {
    const states = claimStatusMap(theme);
    return states[type] || {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "unknown",
        type: "unknown",
    };
};

// Options for DynamicTypeFilter, which resolves "blue" and "grey" per theme itself.
const claimStatusFilterOptions = claimStatuses.map(({ value, color }) => ({
    label: `claim_status_${value}`,
    value,
    color,
}));

const customerTypeMap = (theme) => ({
    [customer_type.PRODUCTION]: {
        labelcolor: theme.palette.mode === "dark" ? "blue" : "primary",
        labeltext: "customer_type_production",
        shorttext: "customer_type_prod",
        type: customer_type.PRODUCTION,
    },
    [customer_type.TESTING]: {
        labelcolor: "orange",
        labeltext: "customer_type_testing",
        shorttext: "customer_type_test",
        type: customer_type.TESTING,
    },
    [customer_type.DEVELOPMENT]: {
        labelcolor: "pink",
        labeltext: "customer_type_development",
        shorttext: "customer_type_dev",
        type: customer_type.DEVELOPMENT,
    },
    [customer_type.INACTIVE]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "customer_type_inactive",
        shorttext: "customer_type_inact",
        type: customer_type.INACTIVE,
    },
    [customer_type.UNKNOWN]: {
        labelcolor: theme.palette.mode === "dark" ? "greyLight" : "grey",
        labeltext: "customer_type_unknown",
        shorttext: "customer_type_unk",
        type: customer_type.UNKNOWN,
    },
});

const getCustomerTypeData = (type, theme) => {
    const states = customerTypeMap(theme);
    return states[type] || states[customer_type.UNKNOWN];
};

export {
    orderStateMap,
    invoiceStateMap,
    returnStateMap,
    inboundStateMap,
    getOrderStateData,
    getInboundStateData,
    getInvoiceStateData,
    getProductsStateData,
    getLocationsStateData,
    getBolReplenishmentStateData,
    getAmazonReplenishmentStateData,
    amazonReplenishmentStateMap,
    getPickingJobStateData,
    getWarehouseLocationLabelData,
    getReturnStateData,
    getImportOrderStateData,
    getCountingStategyLabelData,
    serialNumberStateLabeldata,
    getSerialNumberStateLabeldata,
    getPickingJobStepData,
    getReplenishStateData,
    replenishStateMap,
    bolReplenishmentStateMap,
    getInvoiceMutationStateData,
    invoiceMutationStateMap,
    getShipmentStatusLabeldata,
    shipmentStatusMap,
    claimStatusMap,
    getClaimStatusLabeldata,
    claimStatusFilterOptions,
    orderRelationStateMap,
    customerTypeMap,
    getCustomerTypeData,
    relationStateLabelData,
    getRelationStateLabelData,
    supportTicketStateMap,
    getSupportTicketStateData,
    supportTicketPriorityMap,
    getSupportTicketPriorityData
}
